var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_463_6973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 19.3625L70.5813 0L50 17.3187L79.6625 35.775L100 19.3625ZM29.4187 0L0 19.3562L20.3438 35.775L50 17.3187L29.4187 0ZM50 54.2375L29.4187 71.5563L0 52.1937L20.3375 35.775L50 54.2375L79.6562 35.775L100 52.1937L70.5813 71.5563L50 54.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0688 78.0566C71.5083 78.4296 70.8417 78.6099 70.1697 78.5705C69.4976 78.531 68.8567 78.2739 68.3438 77.8379L50 62.4004L31.6562 77.8379C31.14 78.2697 30.4986 78.5241 29.8268 78.5635C29.1549 78.6029 28.4881 78.4252 27.925 78.0566L18.75 72.0191V81.2504L50.0625 100L81.25 81.2504V72.0129L72.0688 78.0566Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_463_6973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.a484e6e2aff9c73885f24b4361a103fa.svg";
export { ForwardRef as ReactComponent };